export default __webpack_public_path__ + "static/media/search_icon_purple.72a4c843.svg";